export default __webpack_public_path__ + "img/favicons/apple-touch-icon-120x120.png";